import { CUSTOMER_JOURNEY_SERVICES } from './../const';

function action(catId, token, lang, context) {
  return { type: CUSTOMER_JOURNEY_SERVICES, catId, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyServices.js